//@ts-ignore
import { Type } from 'class-transformer';
import { Base } from '../Base/Base';

export class CampaignProduct extends Base {
    @Type(() => Number)
    seedPriceInDollars: number;

    @Type(() => Number)
    durationInSeconds: number;

    @Type(() => Number)
    media_id: number;

    @Type(() => Number)
    number_of_platforms: number;

    @Type(() => Number)
    est_fb_impressions_per_dollar_low: number;
    @Type(() => Number)
    est_fb_impressions_per_dollar_high: number;

    @Type(() => Number)
    est_bw_impressions_per_dollar_low: number;
    @Type(() => Number)
    est_bw_impressions_per_dollar_high: number;

    @Type(() => Number)
    est_nd_impressions_per_dollar_low: number;
    @Type(() => Number)
    est_nd_impressions_per_dollar_high: number;

    @Type(() => String)
    videoDiscountString: string;

    public constructor(data) {
        super(data);
    }
}
